import { useState } from 'react';
import moment from 'moment-timezone';

import Button from '../../Buttons/Button/Button';
import Calendar from '../../inputs/Calendar/Calendar';

import classes from './FilterDates.module.scss';

const FilterDates = ({ className, initDate1, initDate2, onApply, setDatesHandler, showApply = true }) => {
  const [dates, setDates] = useState({ date1: initDate1, date2: initDate2 });

  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div className={containerClasses.join(' ')}>
      {[
        { key: 'date1', value: dates.date1, label: 'Fecha de inicio' },
        { key: 'date2', value: dates.date2, label: 'Fecha de fin' }
      ].map(({ key, value, label }) => {
        let minDate = null;
        let maxDate = null;
        if (key === 'date1') {
          minDate = new Date('2020-01-01');
          maxDate = moment(dates.date2).toDate();
        } else {
          minDate = moment(dates.date1).toDate();
          maxDate = moment().add(1, 'month').toDate();
        }
        return (
          <div key={key} className={classes['date-container']}>
            <span>{label}</span>
            <Calendar
              value={moment(value)}
              onChange={newDate => {
                setDates(prevDates => ({ ...prevDates, [key]: newDate }));
                if (setDatesHandler) {
                  setDatesHandler(key, newDate);
                }
              }}
              views={['year', 'month']}
              format='yyyy - MM'
              minDate={minDate}
              maxDate={maxDate}
            />
          </div>
        );
      })}
      {showApply && (
        <Button className={classes['apply-dates']} onClick={() => onApply(dates)}>
          Aplicar
        </Button>
      )}
    </div>
  );
};

export default FilterDates;
